<footer class="footer-area" *ngIf="!loading" [innerHtml]="footerSetting.html_code">
</footer>

<div class="go-top" pageScroll [href]="'#home'" [pageScrollSpeed]="500"><i class="icofont-swoosh-up"></i></div>
